<!-- DESKTOP ==================================================================== -->

<div
	class="container-fluid schedule-container"
	(window:resize)="onResize()"
	[@enterAnimation]
	*ngIf="!isMobile"
>
	<div class="row">
		<!-- MAIN CONTENT ============================================================= -->
		<section class="sec-container sched col-md-9">
			<!-- New session. -->
			<div
				id="config-newAppointment"
				class="row user-card shadow"
				style="text-align: center"
			>
				<div id="avMainTitle" style="float: left">
					<h1>{{ 'USERMENU.AVAILABILITIES' | translate }}</h1>
				</div>

				<div id="avBtnAdd" style="float: right; margin: -10px 0">
					<button *ngIf="!editMode" class="btn btn-primary" (click)="addNew()">
						{{ 'OPERATIONS.ADD' | translate }}
					</button>
					<button *ngIf="editMode" class="btn btn-primary" (click)="listAll()">
						{{ 'OPERATIONS.LIST' | translate }}
					</button>
				</div>
			</div>

			<!-- Availabilities list. -->
			<app-list-availabilities
				*ngIf="!editMode"
				[currentTimezone]="currentTimezone"
				[resetProfileCompletion]="resetProfileCompletion"
				(editMode)="changeScreenMode($event)"
			>
			</app-list-availabilities>
			<!-- Add or edit availabilities. -->
			<app-manage-availabilities
				*ngIf="editMode"
				[slotTimezone]="slotTimezone"
				[newPeriodDateFrom]="newPeriodDateFromD"
				[newPeriodDateTo]="newPeriodDateToD"
				[availabilityForEdit]="availabilityForEdit"
				[isAddNew]="isAddNew"
				[resetProfileCompletion]="resetProfileCompletion"
				(editMode)="changeScreenMode($event)"
			>
			</app-manage-availabilities>
		</section>

		<!-- SIDEBAR ================================================================== -->
		<div class="col-md-3">
			<!--Data validation -->
			<div class="row">
				<div class="col-xs-12 sidebar-widget">
					<app-alert-info-status
						class="bank-alert-container"
					></app-alert-info-status>
				</div>
			</div>
			<!-- Profile Completion -->
			<div class="row">
				<div class="col-xs-12 sidebar-widget">
					<app-profile-completion
						[reset]="resetProfileCompletion"
						[hideDetails]="showHideDetails"
					></app-profile-completion>
				</div>
			</div>
			<!-- Show appointments of a day. -->
			<div class="row">
				<div class="col-xs-12 sidebar-widget">
					<app-list
						*ngIf="sidebarVisible === 'Appointments'"
						[activeSidebar]="activeSidebar"
						(showEvent)="changeActiveSidebar($event)"
						(showTodayEvents)="changeActiveSidebar($event)"
					></app-list>
				</div>
			</div>
		</div>

		<!-- Show details -->
		<app-details
			*ngIf="!isMobile && modalVisible === 1"
			[activeSidebar]="activeSidebar"
			(rescheduleEvent)="reschedule($event)"
			(showEvents)="changeActiveSidebar($event)"
			(refreshEvents)="forceToRefreshEvents($event)"
		></app-details>

		<appointment-details-sidebar 
			[isVisible]="modalVisible === 4"
			[activeSidebar]="activeSidebar"
			(schedulNewSessionEvent)="createNewEvent($event)"
			(rescheduleEvent)="reschedule($event)"
			(showEvents)="changeActiveSidebar($event)"
		></appointment-details-sidebar>

		<!-- Show form. -->
		<appointment-sidebar
			(refreshEvents)="forceToRefreshEvents($event)"
		></appointment-sidebar>
	</div>
</div>

<!-- MOBILE ===================================================================== -->

<section id="mobile-availabilities" *ngIf="isMobile">
	<!-- HEADER. -->
	<section class="mobileSingleHeader">
		<img class="mnuIcon" src="/assets/images/icons/calendar.svg" />
		<span class="pageTitle">{{ sectionTitle }}</span>
		<fa-icon
			icon="times"
			class="times"
			(click)="goToPage('calendar')"
		></fa-icon>
	</section>
	<!-- /mobileSingleHeader. -->

	<!-- List. -->
	<app-mobavailabilities-list
		*ngIf="mobileMode === 2"
		(addAvailability)="addNewAvailabilityMobile()"
		(editAvailability)="editAvailabityMobile($event)"
	></app-mobavailabilities-list>

	<!-- Add. -->
	<app-mobavailabilities-manage
		*ngIf="mobileMode === 0"
		[currentTimezone]="currentTimezone"
		[newPeriodDateFrom]="newPeriodDateFromD"
		[newPeriodDateTo]="newPeriodDateToD"
		[availabilityForEdit]="availabilityForEdit"
	></app-mobavailabilities-manage>

	<!-- Edit. -->
	<app-mobavailabilities-edit
		*ngIf="mobileMode === 1"
		[currentTimezone]="currentTimezone"
		[newPeriodDateFrom]="newPeriodDateFromD"
		[newPeriodDateTo]="newPeriodDateToD"
		[availability]="availabilityForEdit"
		(cancelEdit)="cancelEditMobile()"
	></app-mobavailabilities-edit>
</section>
